<template>
  <div class="container" v-loading.fullscreen="loading" element-loading-background="rgba(0, 0, 0, 0.5)" element-loading-text="正在导出...">
    <div class="container-content">
      <div class="content-title">单位报告</div>
      <div class="content-item">
        <OrganizationTree @nodeClick="nodeClick"></OrganizationTree>
        <div class="content-right">
          <div class="right-title">报告</div> 
          <div class="query">
            <MyForm class="search-form" :formOptions="queryForm" :inline="true"></MyForm>
          </div>
          <div class="table">
            <MyTable :table-options="tableOptions" border max-height="65vh">
              <template #type="{ row }">
                {{ ['自定义','年报','季报','月报'][row.type] }}
              </template>
              <template #section="{ row }">
                <span v-if="row.type === 0">{{ dayjs(row.startDate).format('MM月DD日')+' — '+dayjs(row.endDate).format('MM月DD日') }}</span>
                <span v-if="row.type === 1">{{ dayjs(row.startDate).format('YYYY年')+' — '+dayjs(row.endDate).format('YYYY年') }}</span>
                <span v-if="row.type === 2">{{ dayjs(row.endDate).format('第Q季度') }}</span>
                <span v-if="row.type === 3">{{ dayjs(row.startDate).format('MM月')+' — '+dayjs(row.endDate).format('MM月') }}</span>
              </template>
              <template #handler="{ row }">
                <el-button style="color: #6fcaf7" link icon="View" @click="previewReport(row)">预览报告</el-button>
                <MyButton link icon="link_export" @click="downloadUnitReport(row)">数据导出</MyButton>
              </template>
            </MyTable>
          </div>
        </div>
      </div>
      <MyPagination :params="paginationParams" :total="total" @get-list="getUnitReportList" ref="paginationRef" />
    </div>
    <Dialog
      width="50%"
      v-model="addVisible"
      title="新增"
      top="5vh"
      @closed="myFormRef.clearData()"
    >
      <MyForm
        class="addReportForm"
        :formOptions="addReportForm"
        ref="myFormRef"
        label-width="auto"
      >
        <template #customize="{ formData }">
          <div class="customize" v-if="formData.type == 1">
            <el-date-picker v-model="formData.customize[0]" type="year" value-format="YYYY" :disabled-date="(time) => time.getTime() > new Date(formData.customize[1]||undefined).getTime()" @change="handleYear"></el-date-picker>
            <span>至</span>
            <el-date-picker v-model="formData.customize[1]" type="year" value-format="YYYY" :disabled-date="(time) => time.getTime() < new Date(formData.customize[0]||undefined).getTime()" @change="handleYear"></el-date-picker>
          </div>
          <div class="customize" v-if="formData.type == 2">
            <el-date-picker v-model="formData.customize[0]" type="year" value-format="YYYY" @change="handleSeason"></el-date-picker>
            <span>年</span>
            <el-select v-model="formData.customize[1]" placeholder="请选择季度" @change="handleSeason">
              <el-option label="第一季度" value="1"></el-option>
              <el-option label="第二季度" value="2"></el-option>
              <el-option label="第三季度" value="3"></el-option>
              <el-option label="第四季度" value="4"></el-option>
            </el-select>
          </div>
          <div class="customize" v-if="formData.type == 3">
            <el-date-picker v-model="formData.customize[0]" type="month" value-format="YYYY-MM" :disabled-date="(time) => time.getTime() > new Date(formData.customize[1]||undefined).getTime()" @change="handleMonth"></el-date-picker>
            <span>至</span>
            <el-date-picker v-model="formData.customize[1]" type="month" value-format="YYYY-MM" :disabled-date="(time) => time.getTime() < new Date(formData.customize[0]||undefined).getTime()" @change="handleMonth"></el-date-picker>
          </div>
          <div class="customize" v-if="formData.type == 0">
            <el-date-picker v-model="formData.customize[0]" type="date" value-format="YYYY-MM-DD" :disabled-date="(time) => time.getTime() > new Date(formData.customize[1]||undefined).getTime()" @change="handleDate"></el-date-picker>
            <span>至</span>
            <el-date-picker v-model="formData.customize[1]" type="date" value-format="YYYY-MM-DD" :disabled-date="(time) => time.getTime() < new Date(formData.customize[0]||undefined).getTime()" @change="handleDate"></el-date-picker>
          </div>
        </template>
      </MyForm>
      <div class="submit-buttons">
        <el-button @click="addVisible = false">取消</el-button>
        <el-button @click="click_confirm">确定</el-button>
      </div>
    </Dialog>   

    <PreviewReportDialog ref="previewDialog"></PreviewReportDialog>
  </div>
</template>

<script setup>
import { reactive, ref,nextTick } from "vue";
import MyTable from "@/components/Global/MyTable.vue";
import MyPagination from "@/components/Global/MyPagination.vue";
import OrganizationTree from "@/components/Common/OrganizationTree.vue";
import organizationApi from "@/api/organization";
import { dayjs } from "element-plus";
import quarterOfYear from 'dayjs/plugin/quarterOfYear'
import PreviewReportDialog from "./previewReportDialog.vue";
import usePrintJS from './components/printList.js'
const { print } = usePrintJS()
dayjs.extend(quarterOfYear);

// 左侧节点点击事件
const currentUnit = ref({});
const nodeClick = (data) => {
  paginationParams.OrganizationId = data.id;
  currentUnit.value = data;
};

// 搜索
const queryForm = reactive({
  itemList: [
    {
      type: "Date",
      label: "月份筛选：",
      prop: "month",
      attrs: {
        type: "month",
        // startPlaceholder: "开始时间",
        // rangeSeparator: "至",
        // endPlaceholder: "结束时间",
        valueFormat: "YYYY-MM-DD",
        class: ["w-200"],
        placeholder: "请选择",
      },
      events: {
        change: (formData, formRef, value) => {
          if (!value) {
            formData.StartDate = undefined;
            formData.EndDate = undefined;
            return;
          }
          formData.year = undefined;
          formData.startDate = dayjs(value).startOf('month').format("YYYY-MM-DD");
          formData.endDate = dayjs(value).endOf('month').format("YYYY-MM-DD");
        },
      },
    },
    [
      {
        type: "Date",
        label: "年份：",
        prop: "year",
        attrs: {
          placeholder: "请选择",
          type: "year",
          valueFormat: "YYYY",
          class: ["w-200"],
        },
        events: {
          change: (formData, formRef, value) => {
            if (!value) {
              formData.StartDate = undefined;
              formData.EndDate = undefined;
              return;
            }
            formData.range = undefined;
            formData.startDate = dayjs(value).startOf('year').format("YYYY-MM-DD");
            formData.endDate = dayjs(value).endOf('year').format("YYYY-MM-DD");
          },
        },
      },
      {
        type: "Button",
        value: "查询",
        attrs: {
          icon: "Search",
          style: {
            marginLeft: "10px",
          }
        },
        events: {
          click(formData) {
            Object.assign(paginationParams,formData)
          },
        },
      },
      {
        type: "Button",
        value: "重置",
        attrs: {
          icon: "Refresh",
        },
        events: {
          click(formData,formRef) {
            formRef.resetFields();
            formData.StartDate = undefined;
            formData.EndDate = undefined;
            Object.assign(paginationParams,formData)
          },
        },
      },
      {
        type: "Button",
        value: "新增报告",
        attrs: {
          icon: "Plus",
        },
        events: {
          click(formData) {
            if(!currentUnit.value?.id){
              return ElMessage.warning("请先选择组织");
            }
            addVisible.value = true;
          },
        },
      },
    ],
    // {
    //   type: "Button",
    //   value: "全部下载",
    //   attrs: {
    //     icon: "Download",
    //     class: ["download"],
    //   },
    //   events: {
    //     click(formData) {
          
    //     },
    //   },
    // },
  ],
});
// 表格数据
const tableOptions = reactive({
  colList: [
    { type: "index", label: "序号", width: 60 },
    { label: "单位名称", prop: "organizationName" },
    { label: "报告名称", prop: "name" },
    { label: "年份", prop: "year" },
    { label: "类型", slot_name: "type", type: "slot" },
    { label: "区间", slot_name: "section", type: "slot" },
    { label: "创建时间", prop: "creationTime" },
    { label: "报告", slot_name: "handler", type: "slot",minWidth: 150 },
  ],
  tableData: [],
});

// 分页
const paginationRef = ref(null);
const total = ref(0);
const paginationParams = reactive({
  
})
const getUnitReportList = (params = paginationRef.value.getList_params) => {
  if(!params.OrganizationId){
    return;
  }
  organizationApi.getUnitReportList(params).then((res) => {
    tableOptions.tableData = res.data.items.map(item => {
      item.creationTime = dayjs(item.creationTime).format("YYYY-MM-DD");
      item.year = dayjs(item.startDate).format("YYYY年");
      item.organizationName = currentUnit.value.name;
      return item;
    });
    total.value = res.data.totalCount;
  })
}

// 新增报告
const addVisible = ref(false);
const myFormRef = ref(null);
const addReportForm = reactive({
  itemList:[
    {
      type: "Input",
      label: "报告名称",
      prop: "name",
    },
    {
      type: "Select",
      label: "类型",
      prop: "type",
      defaultValue: 1,
      options:[
        { label: "年报", value: 1 },
        { label: "季报", value: 2 },
        { label: "月报", value: 3 },
        { label: "自定义", value: 0 },
      ],
      attrs: {
        clearable: false,
      },
      events: {
        change: (formData) => {
          formData.customize = [];
        },
      }
    },
    {
      type: "Slot",
      label: "时间段",
      prop: "customize",
      slot_name: "customize",
      defaultValue: [],
    },
  ],
  rules: {
    name: [{ required: true, message: "请输入报告名称", trigger: "blur" }],
    type: [{ required: true, message: "请选择类型", trigger: "change" }],
    customize: [{ validator: (rule, value, callback) => {
      if(!(value[0] && value[1])){
        callback(new Error("请选择时间段"));
      }else{
        callback();
      }
    }, trigger: "change" }],
  }
});
const handleYear = () => {
  const { formData } = myFormRef.value;
  if(formData.customize[0] && formData.customize[1]){
    formData.startDate = dayjs(formData.customize[0]).startOf('year').format("YYYY-MM-DD");
    formData.endDate = dayjs(formData.customize[1]).endOf('year').format("YYYY-MM-DD");
  }
}
const handleSeason = () => {
  const { formData } = myFormRef.value;
  if(formData.customize[0] && formData.customize[1]){
    formData.startDate = dayjs(formData.customize[0]).quarter(formData.customize[1]).startOf('quarter').format("YYYY-MM-DD");
    formData.endDate = dayjs(formData.customize[0]).quarter(formData.customize[1]).endOf('quarter').format("YYYY-MM-DD");
  }
}
const handleMonth = () => {
  const { formData } = myFormRef.value;
  if(formData.customize[0] && formData.customize[1]){
    formData.startDate = dayjs(formData.customize[0]).startOf('month').format("YYYY-MM-DD");
    formData.endDate = dayjs(formData.customize[1]).endOf('month').format("YYYY-MM-DD");
  }
}
const handleDate = () => {
  const { formData } = myFormRef.value;
  if(formData.customize[0] && formData.customize[1]){
    formData.startDate = formData.customize[0];
    formData.endDate = formData.customize[1];
  }
}
const click_confirm = () => {
  const { formData,formRef } = myFormRef.value;
  formRef.validate((valid) => {
    if (valid) {
      formData.organizationId = currentUnit.value.id;
      organizationApi.addUnitReport(formData).then((res) => {
        ElMessage.success("新增成功");
        addVisible.value = false;
        getUnitReportList();
      })
    }
  })
}
const previewDialog = ref(null)
const previewReport = (row)=>{
  console.log(378,previewDialog)
  previewDialog.value.openPrevieDialog(row)
}
const organizationId = ref('')
const downloadReport=(id)=>{
  organizationId.value = id 
}
const rendomEachart = ()=>{
    console.log('渲染完成')
    // nextTick(()=>{
      
    // })
    setTimeout(() => {
      print()
    }, 2000);
}

const loading = ref(false);
const downloadUnitReport = (row)=>{
  loading.value = true;
  organizationApi.downloadUnitReport(row.organizationId).then(res => {
    const aLink = document.createElement('a')
    const blob = new Blob([new Uint8Array(
      atob(res.data)
        .split("")
        .map((c) => c.charCodeAt(0))
    )], { type: 'application/vnd.ms-excel,charset=utf-8' })
    aLink.href = URL.createObjectURL(blob)
    aLink.setAttribute('download',`${currentUnit.value.name}.xls`)
    aLink.click()
    URL.revokeObjectURL(aLink.href); 
    aLink.remove();
  }).finally(() => {
    loading.value = false;
  })
}
</script>

<style lang="scss" scoped>
.content-item {
  display: flex;
  min-height: 60vh;
  .content-right {
    flex: 1;
    overflow: hidden;
    .right-title {
      background: #134e92;
      height: 40px;
      line-height: 40px ;
      color: #66baec;
      display: flex;
      justify-content: space-between;
      padding-left: 20px;
    }
    .query {
      background: #03386a;
      padding: 0 20px;
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      color: #66baec;
      .search-form {
        padding-top: 20px;
      }
    }
  }
}
.search-form {
  display: flex;
  width: 100%;
  :deep(){
    .w-260{
      width: 260px;
    }
    .w-200{
      width: 200px;
    }
    .el-form-item:has(.download){
      margin-left: auto;
      margin-right: 0;
    }
  }
}
.addReportForm {
  padding: 20px 40px 60px;
  :deep(){
    .el-input,.el-select{
      flex: 1;
    }
    .el-range-editor {
      width: 200px;
    }
  }
  .customize {
    display: flex;
    width: 100%;
    gap: 40px;
  }
}
</style>
